<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-sheet class="card-rounded">
                <v-row no-gutters>
                    <v-col cols="12" class="pa-4">
                        <v-row
                            no-gutters
                            justify="space-between"
                            class="mb-3"
                            align="center"
                        >
                            <span class="header-text">{{$t('message.adminPage.announcement.announce')}}</span>
                        </v-row>
                        <v-row no-gutters class="mb-4">
                            <v-col cols="6">
                                <v-row no-gutters
                                    ><span class="caption-text">
                                        {{$t('message.adminPage.announcement.result')}}</span
                                    >
                                </v-row>
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        resultComputed?.resultType == "FAILED"
                                            ? $t('message.adminPage.status.answer.notQualified')
                                            : $t('message.adminPage.status.answer.qualified')
                                    }}</span>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-row no-gutters
                                    ><span class="caption-text">
                                        {{$t('message.adminPage.announcement.score')}}</span
                                    >
                                </v-row>
                                <v-row no-gutters
                                    ><span class="default-text"
                                        >{{
                                            resultComputed?.totalScore
                                        }}
                                        {{$t('message.adminPage.announcement.points')}}</span
                                    >
                                </v-row>
                            </v-col>
                        </v-row>
                        <template v-if="resultComputed?.resultType != 'FAILED'">
                            <v-row no-gutters class="mb-4">
                                <v-col cols="6">
                                    <v-row no-gutters
                                        ><span class="caption-text">
                                            {{$t('message.adminPage.announcement.type')}}</span
                                        >
                                    </v-row>
                                    <v-row no-gutters
                                        ><span class="default-text">{{
                                            resultComputed?.resultType == "PASS"
                                                ? $t('message.adminPage.firstRound')
                                                : $t('message.adminPage.reserveRound')
                                        }}</span>
                                    </v-row>
                                </v-col>
                                <v-col cols="6">
                                    <v-row no-gutters
                                        ><span class="caption-text">
                                            {{$t('message.adminPage.announcement.no')}}</span
                                        >
                                    </v-row>
                                    <v-row no-gutters
                                        ><span class="default-text">{{
                                            resultComputed?.resultType == "PASS"
                                                ? "-"
                                                : resultComputed?.rankNumber
                                        }}</span>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row
                                no-gutters
                                class="mb-4"
                                v-if="
                                    [
                                        'rejection',
                                        'successful_confirmation',
                                        'successful_confirmation_detail',
                                        'successful_enrollment',
                                    ].includes(getStatusState?.value)
                                "
                            >
                                <v-col cols="6">
                                    <v-row no-gutters
                                        ><span class="caption-text">
                                            {{$t('message.adminPage.announcement.confirmationDate')}}</span
                                        >
                                    </v-row>
                                    <v-row no-gutters
                                        ><span class="default-text">{{
                                            resultComputed?.enrollmentDate ==
                                            null
                                                ? "-"
                                                : enrollmentConfirmationDate
                                        }}</span>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </template>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import { formatDateTime } from "@/utils/date";
import i18n from '@/i18n';
export default {
    props: {
        applicantInfo: Object,
        currentStep: String,
    },
    mounted() {
        this.retrievedData();
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        resultComputed() {
            try {
                return this.applicantInfo?.result;
            } catch (error) {
                return {};
            }
        },
        enrollmentConfirmationDate() {
            let newDate = Date.parse(this.resultComputed?.enrollmentDate);
            if (newDate) return formatDateTime(newDate, this.locale);
            else return "";
        },
        getStatusState() {
            let state = {
                register: {
                    icon: "mdi-plus-circle",
                    color: "#7FA2CC",
                    text: i18n.t('message.stepperBar.register'),
                    value: "register",
                },
                successful_payment: {
                    icon: "mdi-currency-usd",
                    color: "#00C487",
                    text: i18n.t('message.step3.status.successfulPayment'),
                    value: "successful_payment",
                },
                pending_payment: {
                    icon: "mdi-currency-usd-off",
                    color: "#FF544A",
                    text: i18n.t('message.step2.pending_payment'),
                    value: "pending_payment",
                },
                exam_unauthorize: {
                    icon: "mdi-close-circle",
                    color: "#FF544A",
                    text: i18n.t('message.step3.status.noQualified'),
                    value: "exam_unauthorize",
                },
                exam_authorize: {
                    icon: "mdi-check-circle",
                    color: "#00C487",
                    text: i18n.t('message.step3.status.qualified'),
                    value: "exam_authorize",
                },
                exam_authorize_by_system: {
                    icon: "mdi-check-circle",
                    color: "#00C487",
                    text: i18n.t('message.step3.status.qualified'),
                    value: "exam_authorize",
                },
                not_qualify: {
                    icon: "mdi-close-circle",
                    color: "#FF544A",
                    text: i18n.t('message.step4.topic.notPass'),
                    value: "not_qualify",
                },
                pending_confirmation: {
                    icon: "mdi-clock",
                    color: "#7FA2CC",
                    text: i18n.t('message.adminPage.waitingConfirmation'),
                    value: "pending_confirmation",
                },
                rejection: {
                    icon: "mdi-close-circle",
                    color: "#FF544A",
                    text: i18n.t('message.step4.status.waiver'),
                    value: "rejection",
                },
                successful_confirmation: {
                    icon: "mdi-clock",
                    color: "#7FA2CC",
                    text: i18n.t('message.adminPage.waitingConfirmation'),
                    value: "successful_confirmation",
                },
                successful_confirmation_detail: {
                    icon: "mdi-check-circle",
                    color: "#FF9800",
                    text: i18n.t('message.formSummit.confirm'),
                    value: "successful_confirmation_detail",
                },
                successful_enrollment: {
                    icon: "mdi-shield-check",
                    color: "#00C487",
                    text: i18n.t('message.adminPage.successfulInitiation'),
                    value: "successful_enrollment",
                },
            };
            if (state[this.applicantInfo?.registrationStatus?.toLowerCase()]) {
                return state[
                    this.applicantInfo?.registrationStatus?.toLowerCase()
                ];
            }
            return {
                icon: "mdi-shield-check",
                color: "#7FA2CC",
                text: i18n.t('message.adminPage.notFoundStatus'),
                value: "status_not_found",
            };
        },
    },
    data() {
        return {
            applicant: {},
        };
    },

    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
    },
};
</script>

<style scoped lang="scss">
.underline-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    /* identical to box height, or 133% */

    text-decoration-line: underline;

    /* Primary/Primary 500 - FF9800 */

    /* color: #ff9800; */
}
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
